import React from 'react';
import type { InlineTokensEditorProps } from '../../../types/editor/inline-tokens.types';
import { InlineTokensSlashMenu } from './inline-tokens-slash-menu';
import { useInlineTokensEditor } from 'src/modules/shared/hooks/editor/inline-tokens-editor';

export const InlineTokensEditor: React.FC<InlineTokensEditorProps> = (
  props
) => {
  const {
    editorRef,
    hasContent,
    slashState,
    filteredCommands,
    handleInput,
    handleKeyDown,
    commitSlashCommand,
  } = useInlineTokensEditor(props);

  const { disabled = false, placeholder, className } = props;

  return (
    <div className="relative w-full">
      {!hasContent && !disabled && placeholder && (
        <div
          className="pointer-events-none absolute inset-x-3 top-2 text-base leading-6 text-gray-400 whitespace-pre-wrap"
          aria-hidden="true"
        >
          {placeholder}
        </div>
      )}
      <div
        ref={editorRef}
        className={`w-full overflow-auto border-0 bg-transparent px-3 pb-3 pt-2 text-base leading-6 text-gray-800 outline-none focus:ring-0 disabled:text-gray-400 whitespace-pre-wrap ${className ?? ''}`}
        contentEditable={!disabled}
        role="textbox"
        tabIndex={disabled ? -1 : 0}
        aria-disabled={disabled}
        aria-multiline="true"
        onInput={handleInput}
        onKeyDown={handleKeyDown}
        suppressContentEditableWarning
      />

      <InlineTokensSlashMenu
        state={slashState}
        commands={filteredCommands}
        onSelect={commitSlashCommand}
      />
    </div>
  );
};
